import { useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"

export function useCounterparties(direction: "buy" | "sell") {
	return useQuery({
		queryKey: ["trading", "counterparties", direction],
		queryFn: () =>
			GET("/api/v1/trading/counterparties", {
				params: { query: { direction } },
			}),
	})
}
